import { Group, Text, ActionIcon } from "@mantine/core";
import { ChevronLeft, ChevronRight } from "lucide-react";
import classes from "./Pagination.module.css";

interface PaginationProps {
  /** Current page, 1-based. */
  page: number;
  /** How many rows the current page actually returned. */
  shown: number;
  /** Whether a next page is expected (usually `shown >= pageSize`). */
  hasNext: boolean;
  onChange: (page: number) => void;
}

/** Page switcher: bare square arrows that only light up on hover. */
export function Pagination({ page, shown, hasNext, onChange }: PaginationProps) {
  return (
    <Group justify="center" gap="xs" align="center">
      <ActionIcon
        className={classes.arrow}
        variant="subtle"
        color="gray"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        aria-label="Предыдущая страница"
      >
        <ChevronLeft size={16} />
      </ActionIcon>
      <Text fz="sm" c="dimmed">Страница {page} · Показано: {shown}</Text>
      <ActionIcon
        className={classes.arrow}
        variant="subtle"
        color="gray"
        disabled={!hasNext}
        onClick={() => onChange(page + 1)}
        aria-label="Следующая страница"
      >
        <ChevronRight size={16} />
      </ActionIcon>
    </Group>
  );
}
